import axios from "axios"

const fetchGetSentMessageRequest = () => {
	return {type: "FETCH_GET_SENT_MESSAGE_REQUEST"}
}

const fetchGetSentMessageSuccess = (sent_messages) => {
	return {type: "FETCH_GET_SENT_MESSAGE_SUCCESS", payload: sent_messages}
}

const fetchGetSentMessageFailure = (error) => {
	return {type: "FETCH_GET_SENT_MESSAGE_FAILURE", payload: error}
}

export const fetchGetSentMessage = () => {
	return (dispatch) => {
		dispatch(fetchGetSentMessageRequest())
		axios.get("admin/system/message")
		.then(response => {
			const sent_messages = response.data
			dispatch(fetchGetSentMessageSuccess(sent_messages))
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchGetSentMessageFailure(error))	
		})
	}
}

export const fetchGetSentMessagePagination = (e) => {
	return (dispatch) => {
		dispatch(fetchGetSentMessageRequest())
		axios.get(e)
		.then(response => {
			const sent_messages = response.data
			dispatch(fetchGetSentMessageSuccess(sent_messages))	
		})
		.catch(err => {
			const error = err.message
			dispatch(fetchGetSentMessageFailure(error))	
		})
	}
}